import { FormCheckbox } from '@shared/components';
import { useFormContext } from 'react-hook-form';

import { BULK_PERMISSION_NAME } from '../../constants';
import type { ActionPermissionType, AppRolePermissionForm } from '../../types';
import { autoCheckAction, autoUncheckAction, updateCheckboxIfDefined } from '../../utils';

interface SinglePermissionCheckboxProps {
  category: string;
  name: string;
  action: ActionPermissionType;
}

export default function SinglePermissionCheckbox(props: Readonly<SinglePermissionCheckboxProps>) {
  const { category, name, action } = props;
  const formContext = useFormContext<AppRolePermissionForm>();

  const handleSingleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const manipulatedActions = isChecked ? autoCheckAction(action) : autoUncheckAction(action);

    for (const nextAction of manipulatedActions) {
      updateCheckboxIfDefined(formContext, category, name, nextAction, isChecked);
    }

    formContext.setValue(`${category}.${name}.${action}`, isChecked);

    const actionValuesExceptAll = Object.entries(formContext.getValues(category))
      .filter(([key]) => key !== BULK_PERMISSION_NAME)
      .map(([, value]) => value as Record<string, boolean>);

    const shouldActionCheckAll = actionValuesExceptAll.every((value) => value[action] ?? true);
    updateCheckboxIfDefined(
      formContext,
      category,
      BULK_PERMISSION_NAME,
      action,
      shouldActionCheckAll,
    );

    for (const nextAction of manipulatedActions) {
      const shouldManipulatedActionCheckAll = actionValuesExceptAll.every(
        (value) => value[nextAction] ?? true,
      );
      updateCheckboxIfDefined(
        formContext,
        category,
        BULK_PERMISSION_NAME,
        nextAction,
        shouldManipulatedActionCheckAll,
      );
    }
  };

  return (
    <FormCheckbox
      name={`${category}.${name}.${action}`}
      onChange={handleSingleChange}
      sx={(theme) => ({
        fontSize: '24px',
        color: theme.palette.grey[400],
        p: theme.spacing(0),
      })}
      disabled={false}
    />
  );
}
